import { ReactElement, useState } from 'react';
import { Modal, Button } from '@bphxd/ds-core-react';

export type ConfirmationModalProps = {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => Promise<unknown> | void;
  onCancel?: () => void;
  renderButton: (openModal: () => void) => ReactElement;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  message,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onConfirm,
  renderButton,
}) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal((v) => !v);

  const handleConfirm = async () => {
    try {
      await onConfirm();
      toggle();
    } catch (error) {
      console.error('ConfirmationModal error:', error);
      alert('Action failed');
    }
  };

  return (
    <>
      {renderButton(() => setModal(true))}
      <Modal size="sm" isOpen={modal} onToggleOpen={toggle} centered>
        <Modal.Header className="border-0" onToggleOpen={toggle}></Modal.Header>
        <Modal.Body className="text-center pt-0">
          <p className="opacity-90 mb-2">{title}</p>
          <p className="small lh-1-375 mb-0">
            {message}
          </p>
        </Modal.Body>
        <Modal.Footer className="p-0 d-block">
          <div className="row g-0 m-0 text-center modal-footer-row">
            <div className="col-6 d-grid">
              <Button
                theme="darker"
                level="tertiary"
                size="md"
                className="rounded-0 rounded-bottom-left-3"
                onClick={toggle}
              >
                {cancelButtonText}
              </Button>
            </div>
            <div className="col-6 d-grid">
              <Button
                type="submit"
                level="primary"
                theme="darker"
                size="md"
                className="rounded-0 rounded-bottom-right-3"
                onClick={handleConfirm}
              >
                {confirmButtonText}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
